module.exports = __webpack_public_path__ + "img/home_map_Philippines_lightblue.f6fd49b7.png";